// To match strings ending with REQUEST | SUCCESS | FAILURE
export const requestFlowActionsRegex = /(_REQUEST|_SUCCESS|_FAILURE)$/;

// To match strings ending with REQUEST
export const requestActionRegex = /_REQUEST$/;
